module.exports = __webpack_public_path__ + "img/company_casetwelve.7d11599f.png";